// extracted by mini-css-extract-plugin
export default {"text":"Info_text__pvxk3","light":"Info_light__LwNvA","relative":"Info_relative__0qAR7","icons":"Info_icons__etarM"};